import React, {Component} from "react";
import Detail from "../common/detail";
import Filter from "../common/filter";
import {defaultTableChange} from "../../../../../modules/custom/customTable";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import Button from "../../../../../modules/commons/Button";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleInput from "../../../../../modules/SimpleInput";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import {ACTIVITY_TYPE} from "../../../../common/Constants";
import {leasingPaymentStatus, nameOptions, tableColumns} from "../config";
import PrintFilterModal from "../common/printFilterModal";

class SudahPenagihan extends Component {
    tableColumns = [
        ...tableColumns,
        {
            name: "leasingPaymentId",
            label: "Aksi",
            options: {
                customBodyRender: (val) => (
                    <div style={{display: "flex", alignItems: "center", justifyContent: "space-between"}}>
                        <SimpleButton
                            onClick={() => this.handleShowDetail(val, ACTIVITY_TYPE.VIEW)}
                            category="action_button"
                            icon={
                                <i
                                    className="fa fa-lg fa-eye"
                                    style={{
                                        fontSize: 20,
                                        color: 'red'
                                    }}
                                />
                            }
                        />
                        <SimpleButton
                            onClick={() => this.handleShowDetail(val, ACTIVITY_TYPE.UPDATE)}
                            category="action_button"
                            icon={
                                <i
                                    className="fa fa-lw fa-pencil-alt"
                                    style={{
                                        fontSize: 20,
                                        color: 'red'
                                    }}
                                />
                            }
                        />
                        <SimpleButton
                            onClick={() => this.handleShowDetail(val, ACTIVITY_TYPE.CANCEL)}
                            category="action_button"
                            styles={{fontSize: "20px", fontWeight: "bold", color: 'red'}}
                            icon="X"
                        />
                    </div>
                ),
                setCellProps: () => ({
                    style: {width: "80px"},
                }),
            },
        },
    ];

    constructor(props) {
        super(props);
        this.state = {
            detail: {
                id: "",
                activityType: "",
            },
            filterVisible: false,
            printFilterVisibility: false,
        };
    }

    handleChangePage = (tableState) => {
        this.props.onChangePage(tableState.page + 1);
    };

    handleRowsPerPage = (tableState) => {
        this.props.onChangeRowsPerPage(tableState.rowsPerPage);
    };

    handleShowFilter = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            filterVisible: !prevValue.filterVisible,
        }));
    };

    handleShowDetail = (id, activityType) => {
        if (id === null) {
            this.props.refetch();
        }
        this.setState((prevValue) => ({
            ...prevValue,
            detail: {
                id,
                activityType,
            },
        }));
    };

    handlePrintVisibility = () => {
       this.setState(prev=>({
           ...prev,
           printFilterVisibility: !prev.printFilterVisibility
       }))
    }

    render() {
        return (
            <>
                <div
                    style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        gap: "10px",
                        marginBottom: "10px",
                    }}
                >
                    <SimpleDDL
                        id="select_options_name"
                        name="nameDDL"
                        box="search"
                        placeholder="Nama STNK/Nama Pembeli"
                        containerclassname="margin-bottom-none width width-250px"
                        options={nameOptions}
                        isClearable
                        value={this.props.state.searchData?.nameDDL || null}
                        onChange={(value, {name}) => this.props.onSearchChange(name, value)}
                    />
                    <SimpleInput
                        id="input_text_name"
                        name="nameInput"
                        placeholder="Nama STNK/Nama Pembeli"
                        containerclassname="margin-bottom-none"
                        readOnly={!this.props.state.searchData?.nameDDL}
                        value={this.props.state.searchData?.nameInput}
                        onChange={({target}) => this.props.onSearchChange(target.name, target.value)}
                    />
                    <SimpleButton
                        onClick={this.props.onSubmitSearch}
                        disabled={!this.props.state.searchData?.nameDDL}
                    >
                        Cari
                    </SimpleButton>
                    <SimpleButton onClick={this.props.onClearSearch}>Reset</SimpleButton>
                    <Button type="button" className="btn background-red" onClick={this.handleShowFilter}>
            <span>
              <i className="fa fa-qrcode"></i>
            </span>
                    </Button>
                </div>
                <SimpleDataTable
                    data={this.props.state.dataTable}
                    columns={this.tableColumns}
                    toCount={this.props.state.pagination.totalData}
                    rowsPerPage={this.props.state.pagination.limit}
                    page={this.props.state.pagination.page - 1}
                    options={defaultTableChange(this.handleChangePage, this.handleRowsPerPage)}
                    footerAdditionalButtons={
                        <SimpleButton
                            type="button"
                            text="Cetak"
                            onClick={() => this.handlePrintVisibility()}
                        />
                    }
                />
                {this.state.filterVisible && (
                    <Filter
                        setError={this.props.setError}
                        visible={this.state.filterVisible}
                        state={this.props.state}
                        onClearFilter={this.props.onClearFilter}
                        onFilterChange={this.props.onFilterChange}
                        onSubmitFilter={this.props.onSubmitFilter}
                        onClickClose={() => this.handleShowFilter()}
                    />
                )}
                {this.state.detail.id && (
                    <Detail
                        {...this.props}
                        detail={this.state.detail}
                        kodeCabang={this.props.state.kodeCabang?.value}
                        tab={leasingPaymentStatus.SUDAH_PENAGIHAN}
                        onClickClose={this.handleShowDetail}
                    />
                )}
                {this.state.printFilterVisibility && (
                    <PrintFilterModal
                        type="LAPORAN_SUDAH_PENAGIHAN"
                        setError={this.props.setError}
                        kodeCabang={this.props.state.kodeCabang}
                        filterVisible={this.state.printFilterVisibility}
                        onClickClose={this.handlePrintVisibility}
                    />
                )}
            </>
        );
    }
}

export default SudahPenagihan;
